import { useEffect } from 'react'
import styles from './BanModal.module.scss'
import BidButton from 'elements/BidButton/BidButton'
import renderDangerousHtml from '../../utilities/renderDangerousHtml'

export default function BanModal({
  showModal,
  negativeZ,
  toggleModal,
  modalData,
}: any) {
  const { msg } = modalData

  useEffect(() => {
    const closeModal = (e: any) => {
      if (e.key === 'Escape') {
        toggleModal(false, 'Ban')
      }
    }
    window.addEventListener('keyup', closeModal)
    return () => window.removeEventListener('keyup', closeModal)
  }, []) // eslint-disable-line

  return (
    <div
      className={`transition-opacity duration-200 fixed top-0 left-0 flex justify-center items-center w-full h-screen p-4 xl:pl-50 bg-black/30 ${
        negativeZ ? styles.hide_modal : 'z-50'
      } ${!showModal ? ` opacity-0` : 'opacity-100'}`}
    >
      <div className={`${styles.modal} bg-white rounded-lg`}>
        <div className="py-2 px-6 rounded-t-lg bg-bidfta-yellow text-bidfta-gray-dark font-bold text-sm">
          Warning
        </div>

        <div
          className={`${styles.content} pt-4 pb-2 px-6 text-xs text-center`}
          dangerouslySetInnerHTML={renderDangerousHtml(msg)}
        />

        <div className="flex justify-center pt-2 pb-4 px-6 text-center">
          <div className="mx-1 w-20 border border-bidfta-gray-borderdark rounded-md">
            <BidButton
              label="Close"
              theme="gray"
              callBack={() => toggleModal(false, 'Ban')}
              width="full"
              size="xs"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
